<template>
    <Link :class="[active ? 'bg-gray-200 text-gray-900' : 'text-gray-700 hover:text-gray-900 hover:bg-gray-50']" :href="href" class="group flex items-center px-2 py-2 text-sm font-medium rounded-md">
        <slot></slot>
    </Link>
</template>

<script>
export default {
    props: {
        href: {
            required: true,
            type: String,
        },
        active: {
            required: true,
            type: Boolean,
        },
    },
}
</script>
